import { z } from 'zod';
// Prompt AA — catálogo editable de Áreas (packages/db/src/schema/catalogo_areas.ts:
// columna `nombre`). El campo del wire format es `valor` a propósito, no
// `nombre` — así CatalogoCard.tsx (apps/web) puede reutilizarse tal cual
// para Áreas, con el mismo contrato que ya usa para Giro/Origen/Plataforma/
// Tiers (crearCatalogoItemSchema/actualizarCatalogoItemSchema en catalogos.ts).
export const crearCatalogoAreaSchema = z.object({
    valor: z.string().min(1).max(50),
});
export const actualizarCatalogoAreaSchema = z.object({
    valor: z.string().min(1).max(50),
});
//# sourceMappingURL=catalogo-areas.js.map